/* * @Description: 广告系列管理 * @Author: chenminqun@batmobi.net * @Date:
2018-09-25 15:59:56 * @LastEditors: yanzhigen@batmobi.net * @LastEditTime:
2018-11-17 16:05:41 */
<template>
  <div id="series-detail">
    <!-- 顶部header模块 -->
    <header slot="header" class="c-body-header">
      <div class="header-row">
        <div class="header-row-left">
          <div class="header-button-primary" @click="addPmtShowFun()">
            新增打款记录
          </div>
        </div>
        <div class="header-row-right">
          <!-- 预设日期按钮 -->
          <c-date-picker
            :startDay.sync="tableParams.startDate"
            :endDay.sync="tableParams.endDate"
            @change="getList"
          />
        </div>
      </div>
      <div class="header-row">
        <div class="header-row-left">
          <!-- 搜索 -->
          <Input
            v-if="!selectedCount"
            v-model="tableParams.userName"
            placeholder="请输入客户名"
            class="header-search"
            icon="android-search"
            @on-keydown.enter="getList(true)"
            @on-click="getList(true)"
          />
        </div>
        <div class="header-row-right">
          <!-- 投放状态筛选 -->
          <Dropdown
            trigger="click"
            @on-click="(val) => changeStatus('type', val)"
          >
            <button class="header-button-ghost">
              <span class="header-button-ghost-span"
                >打款类型：{{
                  tableParams.type
                    ? recharge_typeList[tableParams.type].name
                    : "全部"
                }}</span
              >
              <i class="icon header-button-ghost-down"></i>
            </button>
            <DropdownMenu slot="list">
              <DropdownItem
                v-for="(value, index) in recharge_typeList"
                :name="value.value"
                :selected="value.name == tableParams.type"
                :key="index"
                >{{ value.name }}
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>

          <!-- 自定义列 -->
          <!-- <button class="header-button-ghost" @click="onClickDown">
                        <span class="header-button-ghost-span">下载</span>
                    </button> -->
          <!-- 刷新 -->
          <button
            class="header-button-ghost refresh-btn"
            @click="getList(false)"
            title="刷新"
            style="margin: 0"
          >
            <i class="icon icon-refresh"></i>
          </button>
        </div>
      </div>
    </header>
    <!-- 顶部header模块 -->
    <!-- 主体section模块 -->
    <section slot="section" class="c-body-section">
      <template>
        <Table :context="self" :columns="columns1" :data="originData"></Table>
      </template>
    </section>

    <!-- 日期 -->
    <footer slot="footer" class="c-body-footer">
      <!-- 分页器 -->
      <c-page
        :table-params.sync="tableParams"
        :page-bean.sync="pageBean"
        class="foot-row"
        background
        @on-change="getList(false)"
        @on-page-size-change="getList(true)"
      />
    </footer>

    <!-- 新增打款记录 -->
    <AddPaymentRecord
      :addPmtShow="addPmtShow"
      :pmtForm="pmtForm"
      @onBtn="addPmtBtn"
      ref="PmtReset"
    />
    <!--  -->

    <!-- <vue-viewer 
            multiple
            :thumb="imageList"
            list-ul-class="image-list"
            :full="imageList">
        </vue-viewer> -->
    <el-image
      class="el-img-yl"
      fit="cover"
      style="width: 100px;display: none;"
      :src="imageList[0]"
      :preview-src-list="imageList"
    >
    </el-image>
  </div>
</template>
<script>
import mixins from "@/mixins/index.js";
import cBody from "@/components/commons/cBody.vue";
import cDatePicker from "@/components/commons/cDatePicker.vue";
import quota from "@/components/commons/quota.vue";
import cPage from "@/components/commons/cPage.vue";
import cTable from "@/components/commons/manageTable.vue";
import cBid from "@/components/commons/cBid.vue";
import tablelist from "@/server/tablelist.js";
import AddPaymentRecord from "@/view/Payment/AddPaymentRecord.vue";
import { mapState } from "vuex";
import ImageViewer from "vue2-viewer";
import Vue from "vue";
Vue.use(ImageViewer);

export default {
  name: "managementSeries",
  mixins: [mixins],
  components: {
    cTable,
    cBid,
    cBody,
    cDatePicker,
    quota,
    cPage,
    AddPaymentRecord,
  },
  props: {
    tagSeries: {
      type: Number,
    },
  },
  data() {
    return {
      self: this,
      //编辑列表
      editList: [],
      //批量修改预算
      date: [], //批量修改时期
      //显示控制器
      show: {
        date: false,
        dailyBudget: false,
      },
      //推广列表数据
      originData: [],
      //分页对象
      pageBean: {
        currentPage: 1,
        pageSize: 10,
        startNum: 0,
        totalNum: 0,
        totalPage: 1,
      },
      //获取推广列表的参数
      tableParams: {
        page: 1,
        pageSize: 10,
        startDate: this.mixinGetDate("today"),
        endDate: this.mixinGetDate("today"),
        type: "",
        userName: "",
      },
      //汇总
      summary: {},
      //批量操作类型数组
      BatchType: ["开启", "停止", "归档", "预算", "日期"],
      //指标列表
      indicatorList: tablelist["series"],
      tableDefaultIndicator: [
        {
          code: "id",
          id: 0,
          selected: true,
          isDefault: true,
          name: "ID",
          sortor: true,
        },
        {
          code: "series",
          id: 1,
          selected: true,
          isDefault: true,
          name: "广告系列名称",
          sortor: false,
        },
        {
          code: "dropDownStatus",
          id: 100,
          selected: true,
          isDefault: true,
          name: "投放状态",
          sortor: false,
        },
      ],
      recharge_typeList: [
        { name: "全部", value: "" },
        { name: "充值", value: 1 },
        { name: "赠送", value: 2 },
      ],
      addPmtShow: false,
      pmtForm: {
        publisher_id: "", //客户名
        email: "", //邮箱
        recharges: "", //金额
        recharge_time: "", //时间
        currency: "USD",
        recharge_type: "", //类型
        recharge_certify: "", //凭证
      },
      columns1: [
        {
          title: "客户名",
          width: 200,
          key: "userName",
        },
        {
          title: "客户账号(邮箱)",
          minwidth: 200,
          key: "email",
        },
        {
          title: "打款金额",
          width: 100,
          key: "recharges",
        },
        {
          title: "打款时间",
          width: 300,
          key: "rechargeTime",
        },
        {
          title: "货币方式",
          width: 100,
          key: "currency",
        },
        {
          title: "打款类型",
          width: 300,
          key: "rechargeType",
          render: (h, params) => {
            if (params.row.rechargeType == 1) {
              return h("div", null, "充值");
            }
            if (params.row.rechargeType == 2) {
              return h("div", null, "赠送");
            }
          },
        },
        {
          title: "打款凭证",
          key: "id",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.showImg(params);
                    },
                  },
                },
                "查看"
              ),
            ]);
          },
        },
      ],
      data1: [
        // {
        //     name: 'John Brown',
        //     age: 18,
        //     address: 'New York No. 1 Lake Park',
        //     date: '2016-10-03'
        // },
        // {
        //     name: 'Jim Green',
        //     age: 24,
        //     address: 'London No. 1 Lake Park',
        //     date: '2016-10-01'
        // },
        // {
        //     name: 'Joe Black',
        //     age: 30,
        //     address: 'Sydney No. 1 Lake Park',
        //     date: '2016-10-02'
        // },
        // {
        //     name: 'Jon Snow',
        //     age: 26,
        //     address: 'Ottawa No. 2 Lake Park',
        //     date: '2016-10-04'
        // }
      ],

      imageList: [],
      imageItem: "",
    };
  },
  watch: {
    tagSeries: {
      handler(value) {
        if (!value) {
          this.originData.map((item) => (item.selected = false));
        }
      },
      immediate: true,
    },
    // 'tableParams.status'(value) {
    //     if (value == '3') {
    //         this.BatchType = ['预算', '日期', '还原'];
    //     } else {
    //         this.BatchType = ['开启', '停止', '归档', '预算', '日期'];
    //     }
    // },
  },
  computed: {
    ...mapState({
      userData: (state) => state.userData,
      statusValue: (state) => state.promotionManagement.statusValue.series,
      dropdownStatusValue: (state) =>
        state.promotionManagement.dropdownStatusValue,
      statusList: (state) => state.promotionManagement.statusList.series,
      dropdownStatusList: (state) =>
        state.promotionManagement.dropdownStatusList,
      statusText: (state) => state.promotionManagement.statusText,
      statusColor: (state) => state.promotionManagement.statusColor,
    }),
    //已选择
    selectedCount() {
      return this.originData.filter((item) => item.selected).length;
    },
    //已选择数组
    selectedList() {
      return this.originData.filter((item) => item.selected);
    },
  },
  mounted() {
    if (this.$store.state.manageData.series) {
      if (this.$store.state.manageData.series.tableParams) {
        this.tableParams = {
          ...this.$store.state.manageData.series.tableParams,
        };
      }
      if (this.$store.state.manageData.series.indicatorList) {
        this.indicatorList = {
          ...this.$store.state.manageData.series.indicatorList,
        };
      }
    }
    this.$store.dispatch("mangeData", { name: "clear-group" });
    this.$store.dispatch("mangeData", { name: "clear-ad" });
    this.getList(false, true);
  },
  methods: {
    addPmtShowFun() {
      this.$refs.PmtReset.ResetForm();

      this.pmtForm = {
        publisher_id: "", //客户名
        email: "", //邮箱
        recharges: "", //金额
        recharge_time: "", //时间
        currency: "USD",
        recharge_type: "", //类型
        recharge_certify: "", //凭证
      };
      this.addPmtShow = true;
    },
    async addPmtBtn(state) {
      console.log("state", state);

      if (state == "1") {
        let data = this.pmtForm;
        delete data.email;
        let res = await this.$axios.post(this.$port.pmt.addbalanceAdmin, data);
        console.log("res", res);
        this.$axios.commonCallback(res, "提交成功");
        this.addPmtShow = false;
        this.getList(1);
      } else {
        this.addPmtShow = false;
      }
    },
    showImg(item) {
      let list =
        item.row.rechargeCertify && item.row.rechargeCertify.split(",");
      this.imageList = list;
      let data = document.getElementsByClassName("el-img-yl")[0].childNodes[0];
      data.click();
    },

    /**
     * @desc 报表下载
     */
    onClickDown() {
      const params = { ...this.tableParams };
      let queryString = `${this.$port.seriesTable.seriesListDownLoad}?`;
      for (let i in params) queryString += `${i}=${params[i]}&`;
      let columns = [];
      for (let i in this.columns1) {
        this.indicatorList[i].forEach((item) => {
          columns.push(item.code);
        });
      }
      queryString += `columns=id,name,${columns.join(",")}`;
      window.location.href = queryString;
    },

    /**
     * @desc: 保存列表数据项选择
     */
    saveSelected() {
      this.$store.dispatch("mangeData", {
        name: "series",
        value: {
          selectCount: this.originData.filter((item) => item.selected).length,
          selectArray: this.originData.filter((item) => item.selected),
        },
      });
    },

    /**
     * @desc: 确认修改单项参数
     */
    async confirmItem(item) {
      const params = [
        {
          id: item.data.id,
          [item.code]: item.data[item.code],
        },
      ];
      const res = await this.$axios.post(
        this.$port.seriesTable.batchUpdate,
        params
      );
      this.afterSubmit(res);
    },
    /**
     * @desc: 获取推广数据
     * @param {Boolean} isInit: 是否初始化页数
     * @param {Boolean} isLoad: 是否是加载页面
     */
    async getList(isInit, isLoad) {
      // debugger
      if (isInit) this.tableParams.page = 1;
      //获取表格数据 -获取汇总数据
      let params = { ...this.tableParams };

      // let params = {
      //     page: 1,
      //     pageSize: 10,
      //     startDate: this.mixinGetDate('today'),
      //     endDate: this.mixinGetDate('today'),
      //     recharge_type: '',
      //     keyword: '',
      //     // type:'1',
      //     userName:'ADmobile',
      // }
      const resList = await this.$axios.get(this.$port.pmt.seriesList, {
        params,
      });
      if (resList.data.pageBean) this.pageBean = resList.data.pageBean;
      if (resList.data.list) {
        this.summary = resList.data.list[0];
        //如果有选择记录
        const selectArray = this.$store.state.manageData.series.selectArray;
        this.originData = resList.data.list;
        // .filter((item, index) => index > 0)
        // .map((item) => {
        //     item.selected = false;
        //     if (selectArray && selectArray.length > 0) {
        //         if (selectArray.some((ari) => ari.id === item.id)) item.selected = true;
        //     }
        //     return item;
        // });
      }

      let value = {};
      if (isLoad) {
        value = {
          selectCount: this.originData.filter((item) => item.selected).length,
          selectArray: this.originData.filter((item) => item.selected),
        };
      } else {
        value = {
          selectCount: 0,
          selectArray: [],
          tableParams: { ...this.tableParams },
        };
      }
      this.$store.dispatch("mangeData", {
        name: "series",
        value,
      });
    },
    /**
     * @desc: 状态筛选
     * @param {String} name: 选择的状态名
     * @param {String} value: 选择的状态值
     */
    changeStatus(name, value) {
      this.$set(this.tableParams, name, value);
      this.getList(true);
    },
  },
};
</script>
<style lang="scss">
@import "src/style/frequently.scss";
@import "src/style/cModal.scss";
.manage-input-box {
  .ivu-icon-ios-calendar-outline {
    &:before {
      content: "\F3F3" !important;
    }
  }
}
#series-detail {
  .header-search {
    width: 3rem !important;
  }
  #c-body .c-body-section .c-body-table .table-tr {
    .table-td-primary {
      min-width: 0.4rem;
    }
    .table-td-primary:nth-of-type(1) {
      padding-right: 0;
      padding-left: 0.2rem;
    }
    //展示删除创意按钮
  }
  .edit-box {
    justify-content: flex-end;
    display: flex;
    width: 2.5rem;
    position: relative;
    align-items: center;
    .edit {
      width: 2.5rem;
      height: 100%;
      display: flex;
      align-items: center;
      position: absolute;
      flex: 1;
      .close-btn {
        cursor: pointer;
        position: absolute;
        right: 1.2rem;
      }
    }
  }

  .flex-text-title {
    overflow: auto;
    text-overflow: initial;
    white-space: normal;
    max-width: none;
  }

  .image-list {
    margin: 0;
    padding: 0;
    display: none;
  }

  .image-list li {
    display: inline-block;
    margin: 0 10px;
    list-style: none;
    position: relative;
  }

  .image-list li img {
    box-shadow: 0 0 5px #333;
  }

  .icon-remove {
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    background: #f33;
    position: absolute;
    top: -10px;
    right: -10px;
    border-radius: 10px;
    cursor: pointer;
    color: #fff;
  }
  a {
    color: #42b983;
  }
  .ivu-page-item-active a {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Payment/Series.vue